import keys from './sl.json';

function processRelativeTime(number, withoutSuffix, key, isFuture) {
  var format = {
    m: ['eno minuto', 'v minuti'],
    h: ['eno uro', 'v eni uri'],
    d: ['eno dan', 'v enem dnevu'],
    dd: [number + ' dni', number + ' dneh'],
    M: ['en mesec', 'v enem mesecu'],
    MM: [number + ' mesecev', number + ' mesecih'],
    y: ['eno leto', 'v enem letu'],
    yy: [number + ' let', number + ' letih'],
  };
  return withoutSuffix ? format[key][0] : format[key][1];
}

export default {
  locale: 'sl',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
      true {
        { preposition, select,
          at { ob { end } }
          until { { end } }
        }
      }
      other { { duration, plural,
          one { # Dan }
          other { # Dnevi }
        }
      }
    }`,
    statusvalue: `{ whitelistedAgentStatus, select,
      requested { Zaželjena udeležba }
      blocked { Dostop blokiran }
      other {

        { roundNumber, select,
          0 {
            { content, select,
              Preview { Predogled }
              Resolved { Rešeno }
              other { {content} }
            }
          }
          other {
            { roundType, select,
              sealed_bidding { Zapečaten postopek }
              open_bidding { Odprti postopek }
              counteroffer_bidding { Nasprotni postopek }
              incremental_auction { Prilagodljiv postopek }
              registration { Registracija }
              simple_offer { Ponudba digitalnega nakupa }
            }

            { roundStatus, select,
              opened { odprt }
              started { začel }
              closed { zaprt }
              other { {roundStatus} }
            }
          }
        }
      }
    }`,
    'RoundInfo::label': `
      { type, select,

        sealed_bidding { Zapečaten postopek dražbe }
        open_bidding { Odprti postopek dražbe }
        incremental_auction { Prilagodljiv postopek dražbe }
        registration { Registracija }
        simple_offer { Ponudba digitalnega nakupa }
        counteroffer_bidding { Nasprotni postopek }
      }
      ({ number }. krog)
      { status, select,
        started { še ni odprt }
        opened
        {
          { hasEnd, select,
            true {
              { durationType, select,
                  fixed {
                    { isPreview, select,
                      true { se začne {startDuration} }
                      false {
                        { isPast, select,
                          false { se zaključi čez {endDuration} }
                          other { je zaključen }
                        }
                      }
                    }
                  }
                  flexible {
                    { durationInDays, plural,
                    one { se zaključi čez 1 dan }
                    other { se zaključi čez {durationInDays} dnech  }
                  }
                }
              }
            }
            other {  }
          }
        }
        closed { je zaprt v { endText } }
        other { {status} }
      }
    `,
  },

  moment: {
    months:
      'Januar_Februar_Marec_April_Maj_Junij_Julij_Avgust_September_Oktober_November_December'.split(
        '_'
      ),
    monthsShort:
      'jan._feb._mar._apr._maj_jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort: 'Ne._Po._To._Sr._Če._Pe._So.'.split('_'),
    weekdaysMin: 'Ne_Po_To_Sr_Če_Pe_So'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD.MM.YYYY',
      LL: 'D. MMMM YYYY',
      LLL: 'D. MMMM YYYY HH:mm',
      LLLL: 'dddd, D. MMMM YYYY HH:mm',
    },
    calendar: {
      sameDay: '[danes ob] LT [uri]',
      sameElse: 'L',
      nextDay: '[jutri ob] LT [uri]',
      nextWeek: 'dddd [ob] LT [uri]',
      lastDay: '[včeraj ob] LT [uri]',
      lastWeek: '[zadnji] dddd [ob] LT [uri]',
    },
    relativeTime: {
      future: 'v %s',
      past: 'zadnjih %s',
      s: 'nekaj sekund',
      ss: '%d sekund',
      m: processRelativeTime,
      mm: '%d minut',
      h: processRelativeTime,
      hh: '%d ur',
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime,
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/sl.js